import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, CircularProgress, FormControlLabel, Switch, Typography } from '@mui/material'

import { useAnalystReviewsAndCommentsAccessCheck } from '../../features/account/hooks/roleHooks'

type TranslationToggleProps = {
  isTranslating: boolean
  hasTranslation: boolean
  error?: string | null
  onToggle: () => void
  disabled?: boolean
}

/**
 * Shows a translation toggle with loading indicator and error message
 */
export const TranslationToggle: FC<TranslationToggleProps> = ({ isTranslating, hasTranslation, error, onToggle, disabled = false }) => {
  const { t } = useTranslation()
  const hasAnalystReviewsAndCommentsAccessRights = useAnalystReviewsAndCommentsAccessCheck()

  if (!hasAnalystReviewsAndCommentsAccessRights) {
    return null
  }

  return (
    <Box>
      {error && (
        <Typography color="error" variant="caption" display="block" sx={{ mb: 1 }}>
          {error}
        </Typography>
      )}
      <Box display="flex" alignItems="center">
        {isTranslating && <CircularProgress size={16} sx={{ mr: 2 }} />}
        <FormControlLabel
          control={<Switch checked={hasTranslation} onChange={onToggle} disabled={disabled || isTranslating} color="primary" size="small" />}
          label={
            <Box component="span">
              {t('common:translated')}{' '}
              <Typography component="span" variant="caption" sx={{ fontStyle: 'italic', opacity: 0.7 }}>
                ({t('common:translated_by_google')})
              </Typography>
            </Box>
          }
          labelPlacement="end"
        />
      </Box>
    </Box>
  )
}
